import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: "n78qyq6m",
  dataset: "production",
  useCdn: false,
  apiVersion: "2026-01-01",
});
